// Snakbar Actions
export const SET_SUCCESS_SNACKBAR = 'SET_SUCCESS_SNACKBAR';
export const SET_ERROR_SNACKBAR = 'SET_ERROR_SNACKBAR';
export const CLEAR_SNACKBAR = 'CLEAR_SNACKBAR';

// Templates Action
export const GET_ONE_TEMPLATE: string = 'GET_ONE_TEMPLATE';
export const TEMPLATE_LOADING: string = 'TEMPLATE_LOADING';
export const TEMPLATE_PAGINATION_CHANGE: string = 'TEMPLATE_PAGINATION_CHANGE';
export const TEMPLATE_SEARCH: string = 'TEMPLATE_SEARCH';
export const SET_UPLOADED_IMAGES: string = 'SET_UPLOADED_IMAGES';
export const SET_ROS_OFFER_PERCENTAGE = 'SET_ROS_OFFER_PERCENTAGE';
export const CLEAR_ALL_TEMPLATE: string = 'CLEAR_ALL_TEMPLATE';
export const CLEAR_TEMPLATE_FIELDS: string = 'CLEAR_TEMPLATE_FIELDS';
export const LOAD_DATA_FROM_LOCAL_STORAGE: string =
  'LOAD_DATA_FROM_LOCAL_STORAGE';
export const CLEAR_TEMPLATE: string = 'CLEAR_TEMPLATE';

//Product
export const SELECT_PRODUCT: string = 'SELECT_PRODUCT';
export const SELECT_POSTCARD: string = 'SELECT_POSTCARD';
export const SET_PRODUCTS: string = 'SET_PRODUCTS';

// Custom Fields Actions
export const SET_CUSTOM_FIELDS = 'SET_CUSTOM_FIELDS';
export const SET_CUSTOM_FIELDS_V2 = 'SET_CUSTOM_FIELDS_V2';
export const SET_PLATFORM_FIELDS = 'SET_PLATFORM_FIELDS';

//Hire Designer Actions
export const SET_HIRE_DESIGNER_FORM_FIELDS = 'SET_HIRE_DESIGNER_FORM_FIELDS';
export const CLEAR_HIRE_DESIGNER_FORM_FIELDS =
  'CLEAR_HIRE_DESIGNER_FORM_FIELDS';

// QR Code Actions
export const SET_QR_URL = 'SET_QR_URL';
export const SET_UTM_SOURCE = 'SET_UTM_SOURCE';
export const SET_UTM_MEDIUM = 'SET_UTM_MEDIUM';
export const SET_UTM_CAMPAIGN_NAME = 'SET_UTM_CAMPAIGN_NAME';
export const SET_QR_SEND_EMAIL = 'SET_QR_SEND_EMAIL';
export const SET_QR_NOTIFICATION_EMAIL = 'SET_QR_NOTIFICATION_EMAIL';
export const SET_CUSTOM_UTMS = 'SET_CUSTOM_UTMS';
export const CLEAR_QR_FIELDS = 'CLEAR_QR_FIELDS';
export const SET_IS_QR = 'SET_IS_QR';
export const SET_QR_DIALOG = 'SET_QR_DIALOG';
export const CLOSE_QR_DIALOG = 'CLOSE_QR_DIALOG';

// Block Colors Actions
export const SET_BLOCK_COLOR = 'SET_BLOCK_COLOR';

// Page Management Actions
export const SET_PAGE_COUNT = 'SET_PAGE_COUNT';

// Clear Redux
export const CLEAR_REDUX: string = 'CLEAR_REDUX';
